export default __webpack_public_path__ + "static/media/Rectangle_71.bb257d58.png";